import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { API_URLS } from '../config';
import {catchError, map} from 'rxjs/operators';
import { AssistPaymentInfo } from '../interfaces/assist-payment-info';
import { AssistPaymentInfoArgs } from '../interfaces/assist-payment-info-args';
import { AvailableTrafficPack } from '../interfaces/available-traffic-pack';
import { TrafficPackHistoryItem } from '../interfaces/traffic-pack-history-item';
import {ActivePack} from '../interfaces/active-pack';
import {DashboardSubscriptionsModel} from '../models/dashboardSubscriptionsModel';
import {TrafficPackExpireInfo} from '../interfaces/traffic-pack-expire-info';

@Injectable({
  providedIn: 'root'
})
export class TrafficPacksService {

  constructor(private http: HttpClient) { }

  getAvailableTrafficPacks(): Observable<AvailableTrafficPack[]> {
    return this.http.get<AvailableTrafficPack[]>(API_URLS.getAvailableTrafficPacks)
      .pipe(
        catchError(response => of([])),
      );
  }
  getAvailableTrafficPacksToModel(model: DashboardSubscriptionsModel): Observable<any> {
    return this.http.get<AvailableTrafficPack[]>(API_URLS.getAvailableTrafficPacks)
      .pipe(
        map((response: AvailableTrafficPack[]) => {
          return model.saveAvailableTrafficPacks(response);
        }),
        catchError(response => of(model)),
      );
  }

  getTrafficPacksHistory(): Observable<TrafficPackHistoryItem[]> {
    return this.http.get<TrafficPackHistoryItem[]>(API_URLS.getTrafficPacksHistory)
      .pipe(
        catchError(response => of([])),
      );
  }

  getTrafficPacksHistoryToModel(model: DashboardSubscriptionsModel): Observable<any> {
    return this.http.get<TrafficPackHistoryItem[]>(API_URLS.getTrafficPacksHistory)
      .pipe(
        map((response: TrafficPackHistoryItem[]) => {
          return model.saveTrafficPacksHistory(response);
        }),
        catchError(response => of(model)),
      );
  }

  getActivePack(): Observable<any> {
    return this.http.get<ActivePack>(API_URLS.getActivePack)
      .pipe(
        catchError(response => of(null)),
      );
  }

  getActivePackToModel(model: DashboardSubscriptionsModel): Observable<any> {
    return this.http.get<ActivePack>(API_URLS.getActivePack)
      .pipe(
        map((response: ActivePack) => {
          return model.saveActivePack(response);
        }),
        catchError(response => of(model)),
      );
  }

  getAssistPaymentInfo(args: AssistPaymentInfoArgs): Observable<AssistPaymentInfo> {
    return this.http.post<AssistPaymentInfo>(API_URLS.getAssistPaymentInfo, args)
      .pipe(
        catchError(response => of({
          success: false,
          error: 'Серверная ошибка',
        })),
      );
  }

  getTrafficPackExpireInfo(trafficPackId: number): Observable<any> {
    return this.http.get<TrafficPackExpireInfo>(`${API_URLS.getTrafficPackExpireInfo}/${trafficPackId}`)
      .pipe(
        catchError(response => of({
          success: false,
          error: 'Серверная ошибка',
        })),
      );
  }

}
